import { createFileRoute, notFound } from '@tanstack/react-router';

import { PROTOTYPE_TOOLS_ENABLED } from '@/app/configuration/environment';
import { PrototypeControlsPanel } from '@/features/prototype/PrototypeControlsPanel';

/**
 * Direct access is denied — not placeholdered — when prototype tooling is off.
 */
export const Route = createFileRoute('/admin/_app/prototype-controls')({
  beforeLoad: () => {
    if (!PROTOTYPE_TOOLS_ENABLED) throw notFound();
  },
  component: PrototypeControlsPanel,
});
